<template>
  <div class="bg-dark-create" :class="[showmodal ? 'open' : '']"></div>

  <div class="form-create-module create-quiz" :class="[showmodal ? 'open' : '']">
    <div class="modal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Criar Quiz</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="form-label">
                <label> Nome do Quiz </label>
              </div>
              <div class="form-input">
                <input
                  type="text"
                  class="form-control"
                  v-model="name"
                  placeholder="Nome do quiz"
                />
                <small class="alertText" v-show="showAlerts[0]==true">Campo obrigatório e deve ser preenchido corretamente.</small>

              </div>
            </div>
          </div>

          <div class="box" style="display: flex">
          
            <div class="modal-body">
              <div class="form-group">
                <div class="form-label">
                  <label> Nota máxima </label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    v-model="passingGrade"
                    placeholder="10"
                  />
                  <small class="alertText" v-show="showAlerts[1]==true">Campo obrigatório e deve ser preenchido corretamente.</small>

                </div>
              </div>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <div class="form-label">
                  <label> Nota de Aprovação </label>
                </div>
                <div class="form-input">
                  <input
                    type="text"
                    class="form-control"
                    v-model="minimalnote"
                    placeholder="7"
                  />
                  <small class="alertText" v-show="showAlerts[2]==true">Campo obrigatório e deve ser preenchido corretamente.</small>

                </div>
              </div>
            </div>

          </div>

          <div class="modal-body">
            <div class="form-group">
              <div class="form-label">
                <label> Status </label>
              </div>
              <select class="select-mode" v-model="status">
                <option value="1" selected>Ativo</option>
                <option value="0">Desabilitado</option>
              </select>
              <small class="alertText" v-show="showAlerts[3]==true">Campo obrigatório e deve ser preenchido corretamente.</small>

            </div>
          </div>

          <div class="action">
            <button @click="closetab()" class="btn-add-module">
             Cancelar
            </button>
            <button @click="saveInfo()" class="btn-add-module">
              Criar Quiz
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/utils/quiz'
import { mapState } from 'vuex';

export default {
  data() {
    return {
      name: '',
      passingGrade: '',
      minimalnote:'',
      status:1,
      showmodal:false,
      showAlerts:[],
      noErros: false
    }

  },
  props: {
      show: Boolean,
      idQuiz:Boolean
  },
  computed:{
    ...mapState(['token'])
  },
  methods: {
    async cretaeQuiz(){

      const obj ={
        "title": this.name,
        "maximum": this.passingGrade,
        "minimum": this.minimalnote,
        "status": this.status
      }
      Object.entries(obj).forEach(([key, value], index) => {
            this.noErros = false;
            if (value==null || value=='') {
              this.showAlerts[index] = true;
              this.noErros = true;    
              }
            });   
            if(this.noErros){
              return;
            }
      try {
        const response = await api.createNewQuiz(obj, this.token)
        this.$emit('create-quiz', response.id)
        this.showmodal = false;
        this.$emit('open-tab', this.showmodal)
      } catch (error) {
        console.error('Erro ao criar o quiz', error)
      }
    },
    saveInfo(){
      this.cretaeQuiz();
      
    },
    closetab() {
          this.showmodal = false;
          this.$emit('open-tab', this.showmodal)
      },
      opentab() {
          this.show = true,
              this.$emit('open-tab', this.showmodal)
      },
  },
  watch: {
      show(novoValor) {
          this.showmodal = this.show;
      },
  },
  created() {
    for (let i = 0; i < 4; i++) {
      this.showAlerts.push(false)
    }
  }
};
</script>

<style scoped>
@import "./tabs.css";
.action {
  display: flex;
  justify-content: end;
  padding: 15px;
  gap: 10px;
}
.form-create-module.create-quiz.open {
  width: 100%;
  z-index: 9999;
}
</style>
